import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MtRolesRouting } from '../../models/mt-roles-routing';
import { ModulTozsamosciAccessCheckerService } from '../../services/modul-tozsamosci-access-checker/modul-tozsamosci-access-checker.service';

@Directive({
  selector: '[authMtIsGranted]'
})
export class MtIsGrantedDirective implements OnChanges {

  constructor(
    private el: ElementRef,
    private mtChecker: ModulTozsamosciAccessCheckerService
  ) { }

  @Input() authMtIsGranted: MtRolesRouting;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.authMtIsGranted) {
      this.setVisibility(this.mtChecker.isAccessGranted(changes.authMtIsGranted.currentValue));
    }
  }

  setVisibility(value: boolean): void {
    this.el.nativeElement.style.display = value ? 'inline-block' : 'none';
  }

}
